export interface WalkthroughGateInput {
  isAdmin: boolean;
  isSupportUser: boolean;
  completed: boolean;
  skipped: boolean;
  seenAt: string | null;
}

// Eenmalige "Aan de slag"-rondleiding op het dashboard: tonen zolang de
// gezien-vlag leeg is, alleen voor klanten die de onboarding voorbij zijn.
export function shouldShowWalkthrough(i: WalkthroughGateInput): boolean {
  if (i.isAdmin || i.isSupportUser) return false;
  if (!i.completed && !i.skipped) return false;
  return i.seenAt === null;
}
